<main class="image-viewer" [class.fit]="!showFullScale">
    <button mat-icon-button class="zoom-button" (click)="closeDialog()" matTooltip="Close">
        <mat-icon>close</mat-icon>
    </button>
    <div class="image-container">
        <img [src]="selectedImageUrl" *ngIf="['png', 'jpeg', 'jpg', 'gif', 'webp'].includes(type)" alt="Preview">
        <video controls autoplay *ngIf="type === 'mp4'">
            <source [src]="selectedImageUrl" type="video/mp4">
            Your browser does not support the video tag.
        </video>
    </div>
</main>